import LoaderImage from './LoaderImage';

export default LoaderImage;
